/* import __COLOCATED_TEMPLATE__ from './team-dropdown.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import ICONS from 'sh-www/constants/assets/icons';
import clsx from 'clsx';

/**
 * Alignments for the dropdown for the Materialize dropdown menu.  Corresponds to their dropdown docs.
 *
 * @type {Object}
 */
export const COMPANY_TEAM_DROPDOWN_ALIGNMENTS = {
  LEFT: 'left',
  RIGHT: 'right',
};

const CLASS_NAME = 'SH-c-company-team-dropdown';
const CIRCLE_BUTTON_DROPDOWN_CLASS_NAME = 'LSG-c-circle-button-dropdown';
const CIRCLE_BUTTON_DROPDOWN_MENU_CLASS_NAME = CIRCLE_BUTTON_DROPDOWN_CLASS_NAME + '__menu-button';
const CIRCLE_BUTTON_DROPDOWN_MENU_DISABLED_CLASS_NAME = CIRCLE_BUTTON_DROPDOWN_MENU_CLASS_NAME + '--disabled';
const DROPDOWN_TRIGGER_CLASS_NAME = 'dropdown-trigger';
const ADD_TO_TEAM_ICON = ICONS.ADD_TO_TEAM;

class CompanyTeamDropdown extends Component {
  get containerClass() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      CIRCLE_BUTTON_DROPDOWN_CLASS_NAME,
    );
  }

  get circleButtonMenuClass() {
    return clsx(
      DROPDOWN_TRIGGER_CLASS_NAME,
      CIRCLE_BUTTON_DROPDOWN_MENU_CLASS_NAME,
      this.args.disabled && CIRCLE_BUTTON_DROPDOWN_MENU_DISABLED_CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get addToTeamIcon() {
    return ADD_TO_TEAM_ICON;
  }

  @action
  onTriggerClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  @action
  onMenuClick(dropdown, fn, e) {
    e.preventDefault();
    e.stopPropagation();
    dropdown.actions.close();
    fn();
  }
}

export default CompanyTeamDropdown;
